import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnalyticEvents } from '@app/enums';
import { validateForm } from '@app/functions/validate-form';
import { Employee } from '@app/models/employee/employee.model';
import { Task } from '@app/models/tasks/task.model';
import { TaskForm } from '@app/modules/forms/company/components';
import { AnalyticService, NotifyService, TaskSubtasksService } from '@app/services';
import { Translatable } from '@app/types/translatable.type';

@Component({
    templateUrl: './employee-tasks-store.template.html',
})
export class EmployeeTasksStoreView implements OnInit {
    isLoading = false;

    title: Translatable;
    employee: Employee;

    task: Task;

    saveButtonCopy: Translatable;

    constructor(
        private route: ActivatedRoute,
        private notify: NotifyService,
        private taskSubtasksService: TaskSubtasksService,
        private location: Location,
        private analyticService: AnalyticService
    ) {
        this.employee = this.route.snapshot.data.models.get('employee');

        if (!(this.task = this.route.snapshot.data.models.get('task'))) {
            this.task = new Task();
            this.task.dueAt = null;
        }

        this.setTitleAndSaveButtonCopy();
    }

    ngOnInit(): void {
        this.task.taskType = 'general';
    }

    onCancel(): void {
        this.location.back();
    }

    async onSave(taskForm: TaskForm): Promise<void> {
        validateForm(taskForm.form);

        if (taskForm.form.invalid) {
            return;
        }

        this.task.subjectId = this.employee.id;

        this.isLoading = true;

        try {
            const task: Task = await this.task.save();
            this.task = task;

            this.taskSubtasksService.onSaveSubTasks(this.task, taskForm.subTasks, taskForm.removedSubTasks);

            this.notify.success('employees.employee-tasks.taskSaved');
            this.analyticService.trackEvent(AnalyticEvents.EmployeeProfileTaskEdited);
            this.location.back();
        } catch (err) {
            this.notify.error(err);
        } finally {
            this.isLoading = false;
        }
    }

    private setTitleAndSaveButtonCopy(): void {
        if (this.task.id) {
            this.title = { key: 'employees.employee-tasks.editTaskFor', params: { name: this.employee.firstName } };
            this.saveButtonCopy = 'employees.employee-tasks.updateTask';
        } else {
            this.title = { key: 'employees.employee-tasks.createTaskFor', params: { name: this.employee.firstName } };
            this.saveButtonCopy = 'employees.employee-tasks.saveTask';
        }
    }
}
